module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-6@3x__1b256d1b4ee8a98e7ee9fec294b4aed1.png";